import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  const includes = ['📘 Ebook PDF completo (30 días)', '📲 Acceso y descarga inmediata', '🔒 Garantía 7 días'];
  return <section id="offer" className="w-full bg-navy text-white py-16 md:py-24" data-id="element-236">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-237">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-238">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-gold mb-12 text-center" data-id="element-239">
            Empieza hoy por menos de lo que cuesta un café.
          </h2>

          <div className="bg-white/10 backdrop-blur-sm rounded-lg overflow-hidden mb-8" data-id="element-240">
            <div className="bg-gold text-navy p-4" data-id="element-241">
              <h3 className="text-xl font-bold text-center" data-id="element-242">
                ✅ Lo que obtienes
              </h3>
            </div>
            <div className="p-6" data-id="element-243">
              {includes.map((item, index) => <div key={index} className="flex items-center justify-between py-3 border-b border-white/20 last:border-0" data-id="element-244">
                  <span className="text-white/90" data-id="element-245">{item}</span>
                  <span className="text-gold font-semibold" data-id="element-246">Incluido</span>
                </div>)}
              <div className="flex items-center justify-between py-4 mt-4 border-t-2 border-gold" data-id="element-247">
                <span className="text-xl font-bold text-gold" data-id="element-248">
                  💰 Total hoy
                </span>
                <span className="text-3xl font-bold text-gold" data-id="element-249">$6.36</span>
              </div>
            </div>
          </div>

          <div className="text-center mb-6" data-id="element-250">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="relative mx-auto max-w-2xl mb-8" data-id="element-251">
              <div className="absolute -inset-4 bg-gold/10 rounded-2xl blur-xl" data-id="element-252" />
              <img src="https://cdn.magicpatterns.com/uploads/nUBoYngDvhRucSAt1oq2Wf/heylloyd-image-1775363601783.png" alt="30 Días con Dios — Ebook en iPad" className="relative w-full rounded-xl shadow-2xl" data-id="element-253" />
            </motion.div>
            <motion.a href="https://pay.hotmart.com/A105236382M" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
            scale: 1.02
          }} whileTap={{
            scale: 0.98
          }} className="inline-block bg-gold text-dark font-bold px-12 py-5 rounded-lg text-xl shadow-2xl hover:brightness-110 transition-all" data-id="element-254">
              Quiero mi acceso ahora — $6.36 →
            </motion.a>
          </div>

          <div className="text-center" data-id="element-255">
            <p className="text-amber-300 font-semibold" data-id="element-256">
              ⚠️ Este es el precio de lanzamiento. Puede aumentar sin previo
              aviso.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}